import type { Entry, EntryFieldTypes, EntrySkeletonType } from 'contentful'

import { type TypeComponentCtaButtonSkeleton } from './component-cta-button'
import { type TypeVariationContainerAuthAndDeviceTypeCtaSkeleton } from './variation-container-auth-and-device-type-cta'

export enum PageHeaderType {
  Global = 'Global',
  NoNavigation = 'No Navigation',
}

export interface TypeHeaderFields {
  internalName: EntryFieldTypes.Symbol
  type: EntryFieldTypes.Symbol<PageHeaderType>
  stickyCtas?:
    | EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaButtonSkeleton>>
    | EntryFieldTypes.Array<
        EntryFieldTypes.EntryLink<TypeVariationContainerAuthAndDeviceTypeCtaSkeleton>
      >
}

export type TypeHeaderSkeleton = EntrySkeletonType<TypeHeaderFields, 'header'>

export type TypeHeaderEntry = Entry<TypeHeaderSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>
